import { render, staticRenderFns } from "./ADossierItem.vue?vue&type=template&id=03e9f251&scoped=true"
import script from "./ADossierItem.vue?vue&type=script&lang=js"
export * from "./ADossierItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e9f251",
  null
  
)

export default component.exports